import { DatepickerOverrides, StatefulCalendar } from 'baseui/datepicker';
import * as React from 'react';

const datePickerOverrides: (overrides) => DatepickerOverrides = (
  overrides,
) => ({
  MonthYearSelectPopover: {
    props: {
      overrides: {
        Body: {
          style: {
            zIndex: 8001,
          },
        },
      },
    },
  },
  Popover: {
    props: {
      overrides: {
        Body: {
          style: {
            zIndex: 8001,
          },
        },
      },
    },
  },
  CalendarHeader: {
    style: {
      paddingLeft: '0px',
      paddingRight: '0px',
      paddingTop: '0px',
      paddingBottom: '10px',
    },
  },
  CalendarContainer: {
    style: {
      paddingLeft: '0px',
      paddingRight: '0px',
      paddingTop: '8px',
      paddingBottom: '0px',
    },
  },
  WeekdayHeader: {
    style: ({ $theme }) => ({
      width: '40px',
    }),
  },
  Day: {
    style: ({ $theme, $selected, $isHovered, $isHighlighted, $disabled }) => ({
      padding: '4px',
      color: $disabled
        ? $theme.colors.skyLight
        : $selected
        ? $theme.colors.white
        : $theme.colors.calendarForeground,
      height: '40px',
      width: '40px',
      ':after': {
        height: '40px',
        width: '40px',
        borderTopColor: 'transparent',
        borderBottomColor: 'transparent',
        borderRightColor: 'transparent',
        borderLeftColor: 'transparent',
        backgroundColor: $selected
          ? $isHovered || $isHighlighted
            ? $theme.colors.primaryDefault
            : $theme.colors.primaryDefault
          : $isHovered || $isHighlighted
          ? $theme.colors.primaryLight
          : 'transparent',
      },
    }),
  },
  ...overrides,
});

export default function MasterCalendarPicker(props) {
  return (
    <StatefulCalendar
      {...props}
      overrides={datePickerOverrides(props.overrides)}
    />
  );
}
